module.exports = __webpack_public_path__ + "img/17.ec0f5ff6.png";